var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 336,
    viewBox: "0 0 106 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.390977,
    y: 0.390977,
    width: 75.0677,
    height: 96.1476,
    rx: 5.86466,
    fill: "url(#paint0_linear_1_2)",
    stroke: "url(#paint1_linear_1_2)",
    strokeWidth: 0.781955
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.4211,
    y: 14.8521,
    width: 45.3534,
    height: 4.69014,
    rx: 2.34507,
    fill: "white",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 16.4211,
    y: 28.9226,
    width: 45.3534,
    height: 4.69014,
    rx: 2.34507,
    fill: "white",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 16.4211,
    y: 42.9929,
    width: 45.3534,
    height: 4.69014,
    rx: 2.34507,
    fill: "white",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.4211,
    y: 57.0634,
    width: 45.3534,
    height: 4.69014,
    rx: 2.34507,
    fill: "white",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 79,
    r: 27,
    fill: "white",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 79C50 63.5599 62.5599 51 78 51C93.4401 51 106 63.5599 106 79C106 94.4401 93.4401 107 78 107C62.5599 107 50 94.4401 50 79ZM54.3377 79C54.3377 92.0457 64.9543 102.662 78 102.662C91.0457 102.662 101.662 92.0457 101.662 79C101.662 65.9543 91.0479 55.3377 78 55.3377C64.9543 55.3377 54.3377 65.9543 54.3377 79ZM80.1689 78.089L87.9768 83.945C88.9355 84.6629 89.1307 86.0228 88.4105 86.9794C87.9854 87.5519 87.3347 87.8491 86.6732 87.8491C86.2199 87.8491 85.7644 87.7081 85.374 87.4153L76.6986 80.9087C76.1521 80.501 75.8311 79.8567 75.8311 79.1736V66.1604C75.8311 64.961 76.8006 63.9915 78 63.9915C79.1994 63.9915 80.1689 64.961 80.1689 66.1604V78.089Z",
    fill: "url(#paint2_linear_1_2)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_2",
    x: 31,
    y: 32,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_1_2",
    x: 46,
    y: 47,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_2",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 37.9248,
    y1: 0,
    x2: 37.9248,
    y2: 96.9296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 37.9248,
    y1: 0,
    x2: 37.9248,
    y2: 96.9296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 56.5,
    y1: 44.5,
    x2: 98.5,
    y2: 114.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 107,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(50 51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitTable);
export default __webpack_public_path__ + "static/media/waitTable.51630f196c04e4504c6dd47a3c047f36.svg";
export { ForwardRef as ReactComponent };